/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2026. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
/**
 * Contains the selectors that select state from the 'ACESWaitlist' store object.
 * @namespace ACESWaitlistSelectors
 */
export default class selectors {
  /**
   * @private
   */
  static moduleIdentifier = 'UAACESWaitlist';

  /**
   * Selects the data from the store.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof ACESWaitlistSelectors
   */
  static postAcesChapWaitlistEnroll = state =>
    state[selectors.moduleIdentifier].postAcesChapWaitlistEnroll.payload;

  /**
   * Selects the flag that is set while the get data request is in progress.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof ACESWaitlistSelectors
   */
  static isFetchingPostAcesChapWaitlistEnroll = state =>
    state[selectors.moduleIdentifier].isFetchingPostAcesChapWaitlistEnroll.payload;

  /**
   * Selects the data errors for the server request.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof ACESWaitlistSelectors
   */
  static postAcesChapWaitlistEnrollError = state =>
    state[selectors.moduleIdentifier].postAcesChapWaitlistEnrollError.payload;

  /**
   * Selects the data from the store.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof ACESWaitlistSelectors
   */
  static fetchAcesChapWaitlistApplied = state =>
    state[selectors.moduleIdentifier].fetchAcesChapWaitlistApplied.payload;

  /**
   * Selects the flag that is set while the get data request is in progress.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof ACESWaitlistSelectors
   */
  static isFetchingFetchAcesChapWaitlistApplied = state =>
    state[selectors.moduleIdentifier].isFetchingFetchAcesChapWaitlistApplied.payload;

  /**
   * Selects the data errors for the server request.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof ACESWaitlistSelectors
   */
  static fetchAcesChapWaitlistAppliedError = state =>
    state[selectors.moduleIdentifier].fetchAcesChapWaitlistAppliedError.payload;

  /**
   * Selects the data from the store.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof ACESWaitlistSelectors
   */
  static fetchAcesChapWaitlistFundAvailable = state =>
    state[selectors.moduleIdentifier].fetchAcesChapWaitlistFundAvailable.payload;

  /**
   * Selects the flag that is set while the get data request is in progress.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof ACESWaitlistSelectors
   */
  static isFetchingFetchAcesChapWaitlistFundAvailable = state =>
    state[selectors.moduleIdentifier].isFetchingFetchAcesChapWaitlistFundAvailable.payload;

  /**
   * Selects the data errors for the server request.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof ACESWaitlistSelectors
   */
  static fetchAcesChapWaitlistFundAvailableError = state =>
    state[selectors.moduleIdentifier].fetchAcesChapWaitlistFundAvailableError.payload;

  /**
   * Selects the data from the store.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof ACESWaitlistSelectors
   */
  static postAcesChapWaitlistSubmitForm = state =>
    state[selectors.moduleIdentifier].postAcesChapWaitlistSubmitForm.payload;

  /**
   * Selects the flag that is set while the get data request is in progress.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof ACESWaitlistSelectors
   */
  static isFetchingPostAcesChapWaitlistSubmitForm = state =>
    state[selectors.moduleIdentifier].isFetchingPostAcesChapWaitlistSubmitForm.payload;

  /**
   * Selects the data errors for the server request.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof ACESWaitlistSelectors
   */
  static postAcesChapWaitlistSubmitFormError = state =>
    state[selectors.moduleIdentifier].postAcesChapWaitlistSubmitFormError.payload;
}
